module.exports = "/assets/site/images/markus_gyorgy_portfoli.jpg?960bc2e4a8ef89fafd0c152285b857d3";